import{jsx as _jsx}from"react/jsx-runtime";import React from"react";import{ButtonInternal}from"./ButtonInternal.js";/**
 * An <a> element styled as a button.
 *
 * @param props The HTML props for the anchor element.
 * @returns A styled anchor element.
 */export const AnchorButton=props=>{return /*#__PURE__*/_jsx(ButtonInternal,{Element:"a",...props})};